import Header from '../components/Header.tsx'
import Footer from '../components/Footer.tsx'
import { Link } from 'react-router-dom'

export default function PrivacyPage() {
  return (
    <>
      <Header />
      <main className="shell legal-page">
        <article className="prose">
          <h1>Privacy Policy</h1>
          <p>Effective date: August 8, 2026</p>
          <p>
            This Privacy Policy explains how heicto.me ("we", "us") handles information
            when you use our HEIC conversion tools.
          </p>

          <h2>Information we process</h2>
          <p>
            Files you select for conversion are processed locally in your browser. We do
            not upload, store, or access your file content on our servers.
          </p>

          <h2>Hosting and logs</h2>
          <p>
            heicto.me is hosted by Cloudflare. Cloudflare may process limited technical
            data, such as IP addresses and request logs, as part of its hosting service.
          </p>

          <h2>Analytics and cookies</h2>
          <p>
            We use Plausible Analytics (hosted at plausible.shipsolo.io), Google Analytics
            4, and Microsoft Clarity to understand aggregate site usage and improve the
            service. These providers may receive page URLs, referrer information, and
            browser or device metadata needed to measure visits. We do not send selected
            conversion files or their contents to these analytics providers.
          </p>

          <h2>Contact us</h2>
          <p>
            Questions about this policy may be sent to{" "}
            <a href="mailto:support@heicto.me">support@heicto.me</a>.
          </p>

          <h2>Governing law</h2>
          <p>
            This Privacy Policy is governed by the laws of the user local jurisdiction.
            Any disclaimers are limited to the maximum extent permitted by applicable local
            law.
          </p>

          <p>
            <Link to="/">← Back to converter</Link>
          </p>
        </article>
      </main>
      <Footer />
    </>
  )
}
